import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/bank-account-integrations/{bankAccountIntegrationId}/permissions']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getBankAccountIntegrationPermissions = async ({ bankAccountIntegrationId }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`/bank-account-integrations/${bankAccountIntegrationId}/permissions`);
  return response.data;
};

export default getBankAccountIntegrationPermissions;
